import React from 'react';
import { restaurantInfo } from '../data/mockData';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Clock, MapPin, Phone, Utensils, ShoppingBag, Truck, Award } from 'lucide-react';

export const InfoSection = () => {
  const daysOrder = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

  const badgeIcons = {
    'Sur place': Utensils,
    'À emporter': ShoppingBag,
    'Livraison': Truck,
    'Halal': Award
  };

  return (
    <section id="info" className="py-24 bg-[#0F0F0F]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2
            className="text-5xl md:text-6xl font-bold text-[#3ABEFF] mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Informations Pratiques
          </h2>
        </div>

        {/* Service Badges */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {restaurantInfo.badges.map((badge, idx) => {
            const Icon = badgeIcons[badge] || Award;
            return (
              <div 
                key={idx} 
                className="flex items-center gap-2 bg-[#D4A85F] text-black px-6 py-3 rounded-lg font-semibold"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                <Icon size={20} />
                {badge}
              </div>
            );
          })}
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Hours */}
          <Card className="bg-[#D4A85F] border-none shadow-xl">
            <CardHeader>
              <CardTitle 
                className="flex items-center gap-3 text-2xl text-black"
                style={{ fontFamily: "'Crimson Text', serif" }}
              >
                <Clock className="text-black" size={28} />
                Horaires d'ouverture
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-3">
                {daysOrder.map((day) => (
                  <div key={day} className="flex justify-between items-center p-3 bg-white/50 rounded-lg">
                    <span 
                      className="font-semibold text-black"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {day}
                    </span>
                    <span 
                      className="text-gray-800 font-medium"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {restaurantInfo.openingHours[day]}
                    </span>
                  </div>
                ))}
              </div>
              <p 
                className="text-center text-black font-bold mt-4 text-lg"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                {restaurantInfo.openingNote}
              </p>
            </CardContent>
          </Card>

          {/* Contact & Location */}
          <div className="space-y-8">
            <Card className="bg-[#D4A85F] border-none shadow-xl">
              <CardHeader>
                <CardTitle 
                  className="flex items-center gap-3 text-2xl text-black"
                  style={{ fontFamily: "'Crimson Text', serif" }}
                >
                  <Phone className="text-black" size={28} />
                  Téléphone
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  {restaurantInfo.phones.map((phone, idx) => (
                    <a
                      key={idx}
                      href={phone.link}
                      className="block p-3 bg-white/50 rounded-lg font-semibold text-black text-lg hover:bg-white/70 transition-colors text-center"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      {phone.number}
                    </a>
                  ))}
                </div>
              </CardContent>
            </Card>

            <Card className="bg-[#D4A85F] border-none shadow-xl">
              <CardHeader>
                <CardTitle 
                  className="flex items-center gap-3 text-2xl text-black"
                  style={{ fontFamily: "'Crimson Text', serif" }}
                >
                  <MapPin className="text-black" size={28} />
                  Adresse
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p 
                  className="text-gray-800 text-lg mb-4"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {restaurantInfo.address}
                </p>
                <a
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(restaurantInfo.address)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-black text-white px-6 py-3 rounded-md font-semibold hover:bg-gray-900 transition-all duration-200 hover:transform hover:-translate-y-0.5"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Obtenir l'itinéraire
                </a>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Google Maps */}
        <Card className="bg-[#D4A85F] border-none shadow-xl overflow-hidden">
          <CardContent className="p-0">
            <div className="w-full h-96">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2630.8!2d2.2589!3d48.7259!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e678e4f4c4f4f5%3A0x1234567890abcdef!2s58%20Avenue%20Raymond%20Aron%2C%2091300%20Massy!5e0!3m2!1sfr!2sfr!4v1704067200000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="PLANETE FOOD Location"
              ></iframe>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};
